module.exports = "build/assets/skyBlueWave.bed06017.png";